import React, { Component } from "react";
import Topo_Mobile from "./Topo_Mobile";
import { verify_mobile } from "../utils/Utils"
export default class TopoParceiros extends Component {
    state = {
       
    };
 
     componentDidMount(){
        
    }

    render() {
        return (
            verify_mobile()?
            <div style={{height:90, backgroundColor:'#030303', zIndex:999999999}} className="ui inverted black top fixed menu transition grid topommm">
                <div style={{width:'100%',display:'flex', alignItems: 'center', justifyContent:'center'}}> 
                    <img width="100%" height="60%" src={`https://files.voitto.com.br/parceiros/cabecalho-${this.props.parceiro}.png`} />
                </div>
            </div>
            :
            <div style={{height:90, backgroundColor:'#030303', zIndex:999999999}} className="ui inverted black top fixed menu transition grid computer only">
                <style>
                    {
                        `
                        #dropper{
                            height: 90px !important;
                        }
                        #div_input2{
                            height: 90px !important;
                            display: flex !important;
                            justify-content: center !important;
                            align-items: center !important;
                        }
                        .ui.inverted.menu .item:before{
                            background-color: #000000 !important;
                        }
                        `
                    }
                </style>
                
                <div style={{width:'95%',marginLeft:'2.5%',display:'flex',justifyContent:'space-between'}}> 
                    <div className="ui item droppedsda" style={{ border:'none', width:90, marginTop:10, marginRight: 18 , objectFit:'contain' }} />
                    <div id="div_input2">
                        <img src={`https://files.voitto.com.br/parceiros/cabecalho-${this.props.parceiro}.png`} />
                    </div>
                    <p style={{fontStyle: "italic", display: "flex", alignItems: "flex-end"}} id="dropper" className="item">
                        Powered by Voitto
                    </p>
                </div>
            
            
            </div>
        )
     
    }
}


const styleEmpresa ={
    div:{
        width: '100%',
        display: 'flex',
        padding: '0.7%',
        // justifyContent: 'space-between',
        paddingLeft: '5%',
        paddingRight: '5%',
        marginTop: '-10px',
        backgroundColor:'rgba(27, 28, 29, 0.85)',
        color:'rgba(255, 255, 255, 0.9)',
        alignItems: 'center',
        height:'90px'
    },
    img:{
        height:'90px',
        width:'140px',
        padding: '4px' 
    },
    p:{
        fontSize: 'large',
        fontWeight: '600',
        width: '100%',
        textAlign: 'center'
    }
}


